<div  class="row" style="outline: none;">
<group-special [group]="group" *ngFor="let group of groups">...</group-special>

</div>
